/* eslint-disable */
export default {
  conferenceCall: 'Conference Call',
  onHold: 'On Hold',
  ongoing: 'Ongoing',
  unknown: 'Unknown',
  disconnected: 'Disconnected',
  loading: 'Loading...',
  loadingTimeout: 'Loading timeout.',
} as const;

// @key: @#@"conferenceCall"@#@ @source: @#@"Conference Call"@#@
// @key: @#@"onHold"@#@ @source: @#@"On Hold"@#@
// @key: @#@"ongoing"@#@ @source: @#@"Ongoing"@#@
// @key: @#@"unknown"@#@ @source: @#@"Unknown"@#@
// @key: @#@"disconnected"@#@ @source: @#@"Disconnected"@#@
// @key: @#@"loading"@#@ @source: @#@"Loading ..."@#@
// @key: @#@"loadingTimeout"@#@ @source: @#@"Loading timeout."@#@
